import React, { forwardRef } from "react";
import hhLogo from "./hh-logo.png";
import "./LessonNotes.css";

function ordinalDay(day) {
  if (day % 10 === 1 && day !== 11) return `${day}st`;
  if (day % 10 === 2 && day !== 12) return `${day}nd`;
  if (day % 10 === 3 && day !== 13) return `${day}rd`;
  return `${day}th`;
}

export function formatCertificateDate(date = new Date()) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // Removed "Given on" prefix
  return `${months[date.getMonth()]} ${ordinalDay(
    date.getDate()
  )}, ${date.getFullYear()}`;
}

const CourseCertificateInfographic = forwardRef(function CourseCertificateInfographic(
  { recipientName, courseTitle, courseCover, givenOn },
  ref
) {
  const name = String(recipientName || "Anonymous User").trim();
  const course = String(courseTitle || "this course").trim();
  const cover = String(courseCover || "").trim();
  const dateLine = givenOn || formatCertificateDate();

  return (
    <div ref={ref} className="course-certificate">
      <div className="course-certificate-frame">
        <span className="course-certificate-corner course-certificate-corner--tl" />
        <span className="course-certificate-corner course-certificate-corner--tr" />

        <h1 className="course-certificate-title">CERTIFICATE</h1>
        <h2 className="course-certificate-subtitle">OF COMPLETION</h2>
        <p className="course-certificate-kicker">PROUDLY PRESENTED TO</p>
        <p className="course-certificate-name">{name}</p>
        <div className="course-certificate-name-line" />
        <p className="course-certificate-body">has successfully completed the course</p>
        {/* Added spacing below */}
        <div style={{ marginTop: "1.8em" }} />
        <div className="course-certificate-course-row">
          {cover ? (
            <img
              className="course-certificate-cover"
              src={cover}
              alt=""
              crossOrigin="anonymous"
            />
          ) : null}
          <p className="course-certificate-course">{course}</p>
        </div>
        
        {/* Moved and grouped logo, org, and note to vertically align between course and date */}
        <div className="course-certificate-branding" style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "2.2em 0 1em 0" }}>
          <img
            className="course-certificate-logo"
            src={hhLogo}
            alt="HH Courses"
            style={{ marginBottom: "0.7em" }}
          />
          <p
            className="course-certificate-org"
            style={{
              marginBottom: "0.5em",
              fontWeight: "bold",
              background: "rgba(0, 0, 0, 0.06)",
              padding: "0.25em 1.2em",
              borderRadius: "0.6em",
              letterSpacing: "0.07em"
            }}
          >
            HH COURSES
          </p>
     
          <p className="course-certificate-note" style={{ fontSize: "2em", textAlign: "center", marginBottom: 0 }}>
            "I'd recommend this course to anyone! Do it at hhcourses.com" -<br /> <span style={{ fontWeight: "bold", fontSize: "0.75em" }}>{name}</span>
       
          </p>
     
        </div>

        <p className="course-certificate-date">{dateLine}</p>
      </div>
    </div>
  );
});

export default CourseCertificateInfographic;
